import type { Company } from "@/services/api/companies";
import { parseISO } from "date-fns";

export function sortCompanies(
  companies: Company[],
  sortColumn: string,
  sortDirection: "asc" | "desc"
): Company[] {
  const sorted = [...companies].sort((a, b) => {
    let comparison = 0;

    switch (sortColumn) {
      case "name":
        comparison = (a.name || "").localeCompare(b.name || "");
        break;
      case "linkedInUrl":
        comparison = (a.linkedInUrl || "").localeCompare(b.linkedInUrl || "");
        break;
      case "isActive":
        comparison = Number(a.isActive) - Number(b.isActive);
        break;
      case "createdDate":
        const createdA = a.createdDate ? parseISO(a.createdDate).getTime() : 0;
        const createdB = b.createdDate ? parseISO(b.createdDate).getTime() : 0;
        comparison = createdA - createdB;
        break;
      default:
        return 0;
    }

    return sortDirection === "asc" ? comparison : -comparison;
  });

  return sorted;
}

